import React, {memo, useCallback} from "react";
import BinIcon from "../../../components/icon/Icon";
import { ZendeskButtonTypes, ZENDESK_BUTTON_TYPES } from "./ZendeskButtonConstants";
import { ZendeskButtonStyled, ZendeskFixedButtonStyled } from "./styled/ZendeskFixedButtonStyled";
import { useZendeskContext } from "../zendeskContext";
import { useGTMEvent } from "../../GoogleTagManager/googleTagManagerHooks";
import { useSelector } from 'react-redux';
import { getIsZendeskInitedSelector } from '../zendeskSelectors';


interface IZendeskButton extends React.ComponentProps<typeof ZendeskFixedButtonStyled | typeof ZendeskButtonStyled> {
    children?: JSX.Element,
    iconFontSize?: string;
    iconColor?: string;
    type?: ZendeskButtonTypes;
}
export const ZendeskButton = memo(({ children, iconFontSize = '32px', iconColor, type, ...props }: IZendeskButton) => {
    const { openWebWidget } = useZendeskContext();
    const { handleGTMClick } = useGTMEvent();
    const isWebWidgetInited = useSelector(getIsZendeskInitedSelector);

    const handleClick = useCallback(() => {
        openWebWidget();
        handleGTMClick({ button: 'ZendeskWebWidget' })
    },[handleGTMClick, openWebWidget])

    const ButtonStyled = type === ZENDESK_BUTTON_TYPES.fixed
        ? ZendeskFixedButtonStyled
        : ZendeskButtonStyled
    return (
        <ButtonStyled onClick={handleClick} disabled={!isWebWidgetInited} {...props}>
            <BinIcon name="IcQuestionMarkBubble" style={{ fontSize: iconFontSize, fill: iconColor }} />
            {children}
        </ButtonStyled>
    );
});